import { Store } from "game/store/gameStore";

export enum GameName {
    KLONDIKE = 'Klondike',
    SPIDER = 'Spider',
    FREECELL = 'Freecell',
    PYRAMID = 'Pyramid',
}
export enum DifficultyLevelType {
    KLONDIKE_MEDIUM_3CARDS = 'KLONDIKE_MEDIUM_3',
    KLONDIKE_HARD_3CARDS = 'KLONDIKE_HARD_3',
    KLONDIKE_EXPERT_3CARDS = 'KLONDIKE_EXPERT_3',

    KLONDIKE_EASY_1CARD = 'KLONDIKE_EASY_1',
    KLONDIKE_MEDIUM_1CARD = 'KLONDIKE_MEDIUM_1',
    KLONDIKE_HARD_1CARD = 'KLONDIKE_HARD_1',
    KLONDIKE_EXPERT_1CARD = 'KLONDIKE_EXPERT_1',

    SPIDER_EASY_1SUIT = 'SPIDER_EASY_1',
    SPIDER_MEDIUM_1SUIT = 'SPIDER_MEDIUM_1',
    SPIDER_HARD_1SUIT = 'SPIDER_HARD_1',
    SPIDER_EXPERT_1SUIT = 'SPIDER_EXPERT_1',

    // 2 Suits:
    SPIDER_MEDIUM_2SUIT = 'SPIDER_MEDIUM_2',
    SPIDER_HARD_2SUIT = 'SPIDER_HARD_2',
    SPIDER_EXPERT_2SUIT = 'SPIDER_EXPERT_2',
    // 4 Suits:
    SPIDER_EXPERT_4SUIT = 'SPIDER_EXPERT_4',
    SPIDER_HARD_4SUIT = 'SPIDER_HARD_4',

    FREECELL_EASY = 'FREECELL_EASY',
    FREECELL_MEDIUM = 'FREECELL_MEDIUM',
    FREECELL_HARD = 'FREECELL_HARD',
    FREECELL_EXPERT = 'FREECELL_EXPERT',

    PYRAMID_EASY = 'PYRAMID_EASY',
}

const difficultyForGameType = [] as DifficultyLevelType[];
export const getFirstDifficulty = () => {
    Object.keys(difficultyLevelData).forEach((key) => {
        switch (Store.name) {
            case GameName.KLONDIKE:
                if (key.includes('KLONDIKE')) {
                    if (key.includes('_' + Store.getDealCount()))
                        difficultyForGameType.push(key as DifficultyLevelType);
                }
                break;
            case GameName.SPIDER:
                if (key.includes('SPIDER')) {
                    if (key.includes('_' + Store.suits))
                        difficultyForGameType.push(key as DifficultyLevelType);
                }
                break;

            case GameName.FREECELL:
                if (key.includes('FREECELL')) {
                    difficultyForGameType.push(key as DifficultyLevelType);
                }
                break;
            case GameName.PYRAMID:
                if (key.includes('PYRAMID')) {
                    difficultyForGameType.push(key as DifficultyLevelType);
                }
                break;
        }
    });
    return difficultyForGameType[0];
}

export const difficultyLevelData: Record<DifficultyLevelType, { type: string, name: GameName }> = {
    [DifficultyLevelType.KLONDIKE_EASY_1CARD]: { type: 'easy', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_MEDIUM_1CARD]: { type: 'medium', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_HARD_1CARD]: { type: 'hard', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_EXPERT_1CARD]: { type: 'expert', name: GameName.KLONDIKE },

    [DifficultyLevelType.KLONDIKE_MEDIUM_3CARDS]: { type: 'medium', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_HARD_3CARDS]: { type: 'hard', name: GameName.KLONDIKE },
    [DifficultyLevelType.KLONDIKE_EXPERT_3CARDS]: { type: 'expert', name: GameName.KLONDIKE },

    [DifficultyLevelType.SPIDER_EASY_1SUIT]: { type: 'easy', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_MEDIUM_1SUIT]: { type: 'medium', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_HARD_1SUIT]: { type: 'hard', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_EXPERT_1SUIT]: { type: 'expert', name: GameName.SPIDER },

    [DifficultyLevelType.SPIDER_MEDIUM_2SUIT]: { type: 'medium', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_HARD_2SUIT]: { type: 'hard', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_EXPERT_2SUIT]: { type: 'expert', name: GameName.SPIDER },

    [DifficultyLevelType.SPIDER_EXPERT_4SUIT]: { type: 'expert', name: GameName.SPIDER },
    [DifficultyLevelType.SPIDER_HARD_4SUIT]: { type: 'hard', name: GameName.SPIDER },

    [DifficultyLevelType.FREECELL_EASY]: { type: 'easy', name: GameName.FREECELL },
    [DifficultyLevelType.FREECELL_MEDIUM]: { type: 'medium', name: GameName.FREECELL },
    [DifficultyLevelType.FREECELL_HARD]: { type: 'hard', name: GameName.FREECELL },
    [DifficultyLevelType.FREECELL_EXPERT]: { type: 'expert', name: GameName.FREECELL },

    [DifficultyLevelType.PYRAMID_EASY]: { type: 'easy', name: GameName.PYRAMID },
};

export const difficultiesList = Object.keys(difficultyLevelData);
